module.exports = __webpack_public_path__ + "img/11.0d4b49f8.png";